/**
 * 通用轮询工具
 * @param {Function} fn 请求函数，返回 Promise，resolve 为结果对象
 * @param {Object} options 配置项
 * @param {Function} options.shouldStop (result) => boolean，返回 true 表示停止并 resolve
 * @param {Function} [options.isError] (result) => Error|null，返回 Error 表示业务失败
 * @param {Function} [options.onResult] (result, count) => void，每次轮询拿到结果时回调（含最终一次）
 * @param {number} [options.interval=15000] 轮询间隔（毫秒）
 * @param {number} [options.maxTimes=40] 最大轮询次数
 */
export function poll (fn, options) {
  const opts = options || {}
  const shouldStop = typeof opts.shouldStop === 'function' ? opts.shouldStop : () => true
  const isError = typeof opts.isError === 'function' ? opts.isError : null
  const onResult = typeof opts.onResult === 'function' ? opts.onResult : null
  const interval = typeof opts.interval === 'number' ? opts.interval : 1000
  const maxTimes = typeof opts.maxTimes === 'number' ? opts.maxTimes : 50

  let count = 0

  async function loop () {
    count++
    const res = await fn()
    if (onResult) {
      try {
        onResult(res, count)
      } catch (e) {
        // ignore
      }
    }
    if (isError) {
      const err = isError(res)
      if (err) {
        throw err
      }
    }
    if (shouldStop(res) || count >= maxTimes) {
      return res
    }
    await new Promise((resolve) => setTimeout(resolve, interval))
    return loop()
  }

  return loop()
}
